import { render, staticRenderFns } from "./resources-examine.vue?vue&type=template&id=371dcfb1&"
import script from "./resources-examine.vue?vue&type=script&lang=js&"
export * from "./resources-examine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports